// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3kXLK","Open":"SideDrawer_Open__1tCv1","Close":"SideDrawer_Close__9j7x-","Logo":"SideDrawer_Logo__3voUv"};